

(function () {

	var callBackNo = 0;
	var readyFnList = [];
	function generateFnName () {
		callBackNo++;
		return 'COVERAPP_CallBack_' + callBackNo;
	}

	var COVERAPP = {
		// 基础属性类
		Attribute: {
			// userAgent
			UA: navigator.userAgent,

			// version
			version: '1.4.0',

			// 判断是否为app
			isApp: function(){
				var ua = this.UA;
				if (/TheCover/i.test(ua)) {
					return true;
				}
				return false;
			},

			// 判断是否是ios
			isIOS: function(){
				var ua = this.UA;
				if (/ios/i.test(ua) || /iphone/i.test(ua) || /ipad/i.test(ua) || /ipod/i.test(ua)) {
				   return true;
				}
				return false;
			},

			// 判断是否是android
			isAndroid: function () {
				var ua = this.UA;
				if (/android/i.test(ua)) {
					return true;
				}
				return false;
			},

			// 获取客户端版本号
			appVersion: function(){
				var ua = this.UA;
				var version = ua.split('(TheCover_')[1].split('_')[0];
				return version;
			},

			// 获取系统类型
			systemType: function(){
				var ua = this.UA;
				var sys = ua.split('(TheCover_')[1].split('_')[1];
				return sys;
			},

			// 设备标识
			deviceId: function(){
				var ua = this.UA;
				var id = ua.split('(TheCover_')[1].split('_')[2];
				return id;
			}
		},

		// 功能方法类
		Method: {
			/**
			 * 主动分享
			 * @param  {Object} obj 参数对象
                *  title: '', // 分享标题 必填
                   desc: '', // 分享描述 必填
                   link: '', // 分享链接 必填
                   imgUrl: '', // 分享图标 必填
                   origin: 'none', // 分享渠道 必填(None: 打开分享选择; Timeline: 朋友圈; Weixin: 微信好友; Qzone: QQ空间; QQ: QQ好友; Weibo: 新浪微博)
			       callback 回调函数名
                    * 回调函数 选填
                    * 回调参数 类型json
                    * origin: string 分享渠道; status: string 分享状态[分享成功：success或者1，分享取消：cancel或者0]
                    * callback: function(ret) {
                        var data = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret;
                        if (data.status == 'success' || data.status == '1') {
                            console.log('分享成功')
                        } 
                    }

			 */
			Share: function(obj){
				var funName = generateFnName()
				window[funName] = obj.callback;
				obj.callback = funName;
				if(COVERAPP.Attribute.isIOS()){
					window.webkit.messageHandlers.Share.postMessage(obj);
					return false;
				}

				if(COVERAPP.Attribute.isAndroid()){
					AndroidBridging.share(JSON.stringify(obj));
					return false;
				}
				
			},

			/**
			 * 被动分享 APP右上角
			 * @param  {Object} obj 参数对象
             *  title: '', // 分享标题 必填
                desc: '', // 分享描述 必填
                link: '', // 分享链接 必填
                imgUrl: '', // 分享图标 必填
                hide: 1, // 控制分享按钮的是否隐藏，1是隐藏，默认显示 非必填
			 *  callback 回调函数名
                * 回调函数 选填
                * 回调参数 类型josn
                * origin: string 分享渠道; status: string 分享状态[分享成功：success或者1，分享取消：cancel或者0]
                callback: function(ret) {
                    var data = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret;
                    if (data.status == 'success' || data.status == '1') {
                        console.log('分享成功')
                    } 
                }

			 */
			onshare: function (obj) {
				var funName = generateFnName()
				window[funName] = obj.callback;
				obj.callback = funName;
				if (COVERAPP.Attribute.isIOS()) {
					try {
						window.webkit.messageHandlers.onShare.postMessage(obj);
					} catch (e) {
					}
				} else {
					if (window.AndroidBridging) {
						window.AndroidBridging.onShare(JSON.stringify(obj));
					}
				}
			},

			/**
			 * 打开登录 成功返回用户信息
			 * @param  {Object} obj 参数对象
			 * @param  {string} obj.needMobile 值为'1'则需要绑定手机号
			 * @param  {string} obj.callback 回调函数名
             * 回调函数 选填
             * 回调参数 类型josn 用户信息
             * 包含device_id(设备唯一标识)、user_id(用户userid)、avatar(头像)、mobile(电话号码)、nickname(昵称)、token(token)
             * callback: function(ret) {
                    var userinfo = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret;
                    if (userinfo.token) {
                        console.log('登录成功')
                    }
                }
			 */
			OpenLogin: function(obj){
				var funName = generateFnName()
				window[funName] = obj.callback;
				obj.callback = funName;
				if(COVERAPP.Attribute.isIOS()){
					window.webkit.messageHandlers.Login.postMessage(obj);
					return false;
				}

				if(COVERAPP.Attribute.isAndroid()){
					console.log('denglu');
					AndroidBridging.login(JSON.stringify(obj));
					return false;
				}
			},

			/**
			 * 获取用户信息 mobile device_id push_id等
			 * @param  {Object} obj 参数对象
			 * @param  {string} obj.callback 回调函数名
             * 回调函数 必填
             * 回调参数 类型josn 用户信息
             * 包含device_id(设备唯一标识)、user_id(用户userid)、avatar(头像)、mobile(电话号码)、nickname(昵称)、token(token)
                callback: function(ret) {
                    var userinfo = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret;
                    if (userinfo.token) {
                        if (COVERAPP.Attribute.isIOS()) {
                            var nickname = decodeURIComponent(escape(window.atob(userinfo.nickname))) // ios内获取的用户昵称需要转码
                        }
                        var user_id = userinfo.user_id
                        var token = userinfo.token
                    }
                }
			 */
			GetUser: function(obj) {
				var funName = generateFnName()
				window[funName] = obj.callback;
				obj.callback = funName;
				if (COVERAPP.Attribute.isIOS()) {
					window.webkit.messageHandlers.wcUser.postMessage(obj);
					return false;
				}
				if (COVERAPP.Attribute.isAndroid()) {
					AndroidBridging.wcuser(JSON.stringify(obj));
					return false;
				}
			},

            /**
                * 调起绑定手机号
                * 回调函数 必填
                * callback: function(ret) {
                    var userinfo = typeof ret == typeof ret != 'string' ? JSON.stringify(ret) : ret;
                    if (userinfo.indexOf('success') > -1) {
                        console.log('绑定手机号成功')
                    }
                }
            **/
            bindMobile (obj) {
                var funName = generateFnName()
				window[funName] = obj.callback;
				obj.callback = funName;
                if (COVERAPP.Attribute.isIOS()) {
                    window.webkit.messageHandlers.bindMobile.postMessage(obj);
                } else if (COVERAPP.Attribute.isAndroid()) {
                    window.AndroidBridging.bindMobile(JSON.stringify(obj));
                }
            },

            // 返回
            Back () {
                if (COVERAPP.Attribute.isIOS()) {
                    window.webkit.messageHandlers.Back.postMessage('');
                } else if (COVERAPP.Attribute.isAndroid()) {
                    window.AndroidBridging.back();
                }
            },

		},

		/**
		 * ready方法 需要确保桥可以使用是，放在ready方法里
		 * @param  {Function} fn 需要执行的函数
		 */
		ready: function (fn) {
			readyFnList.push(fn);
		}
	};

	window.COVERAPP_CallBack_ready = function () {
		for (var i = 0; i < readyFnList.length; ++i) {
			readyFnList[i].call();
		}
	}
	// 调桥失败的方法（桥没有准备好）
	window.COVERAPP_CallBack_error = function (data) {
		// 调用桥失败
	}
	window.COVERAPP = COVERAPP;
}())


// WEBPACK FOOTER //
// ./src/util/COVERAPP.js